import React, { useCallback, useMemo, useState } from 'react'
import { AppTitlePage } from '../../components/AppTitlePage'
import { AppBtnColor } from '../../components/btn/AppBtn'
import { IPopup } from '../CategoriesPage/CategoriesPage'
import { AppFilterInput } from '../../components/AppInput/AppFilterInput'
import { AppTable } from '../../components/AppTable/AppTable'
import { useGetGuestListTypeListQuery } from '../../core/api/GuestTypeApi'
import { useParamsControl } from '../../utils/useParamsControl'
import {
  IGuestsTypeRequest,
  IGuestTypeDto,
} from '../../core/api/dto/GuestTypeDto'
import { AddGuestTypePopup } from './components/AddGuestTypePopup'
import { AppDeletePopup } from '../../entities/AppDeletePopup/AppDeletePopup'

import { useDeleteGuestType } from './hooks/useDeleteGuestType'
import { IChooseItems } from 'core/api/dto/BuffetDishDto'

const headerData = [{ title: 'Наименование', colWidth: '95%', sort: 'name' }]

export const GuestTypePage = () => {
  const pageParams = useParamsControl<
    IGuestsTypeRequest,
    keyof IGuestsTypeRequest
  >({
    withPagination: true,
    whiteList: ['search', 'ordering'],
  })
  const [openCreatePopup, setOpenCreatePopup] = useState<IPopup>({
    active: false,
    id: null,
  })

  const { data: guestTypeList } = useGetGuestListTypeListQuery(
    { ...pageParams, ordering: pageParams?.ordering ?? ['is_archived'] },
    { skip: !pageParams },
  )
  const [chooseItems, setChooseItems] = useState<IChooseItems | null>(null)
  const [tableData, setTableData] = useState<IGuestTypeDto[]>([])

  const {
    deletePopup,
    closeDeletePopup,
    onDeletePopupHandler,
    onDeleteHandler,
  } = useDeleteGuestType(chooseItems, setChooseItems)

  const openEditPopupHandler = useCallback(
    (id: number) => setOpenCreatePopup({ id, active: true }),
    [],
  )

  const closePopupHandler = useCallback(
    () => setOpenCreatePopup({ id: null, active: false }),
    [],
  )

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeletePopupHandler,
    },
  ]

  const actions = useMemo(
    () => [
      {
        btnTitle: 'Добавить тип гостя',
        btnIco: 'add',
        onClick: () =>
          setOpenCreatePopup((prevState) => ({ ...prevState, active: true })),
        color: AppBtnColor.whiteOutlineViolet,
      },
    ],
    [],
  )
  if (!guestTypeList) return null
  return (
    <React.Fragment>
      {openCreatePopup.active && (
        <AddGuestTypePopup
          closePopup={closePopupHandler}
          id={openCreatePopup.id}
        />
      )}
      {deletePopup && (
        <AppDeletePopup onClose={closeDeletePopup} onDelete={onDeleteHandler} />
      )}

      <div className="width-for-page-wrapper">
        <AppTitlePage title="Тип гостя" actions={actions} />
        <div className="col-7-width-from-1000">
          <div className="filter-block no-wrap mt-20">
            <AppFilterInput
              fullWidth
              searchParam={'search'}
              ico={'search'}
              label={'Поиск'}
              placeholder="Например: Ребёнок"
            />
          </div>
          <AppTable
            data={guestTypeList}
            headerData={headerData}
            chooseItems={chooseItems}
            chooseMode
            setChooseItems={setChooseItems}
            setTableData={setTableData}
            tableDataSelectors={[
              {
                renderItem: (item) => (
                  <div
                    className={`table-link ${
                      item.isArchived ? 'delete-item' : ''
                    }`}
                    onClick={() => openEditPopupHandler(item.id)}
                  >
                    {item.name}
                  </div>
                ),
              },
            ]}
            chooseActions={tableActions}
            idName="guest-type"
            // isLoading={isLoadingGet || isFetchingGet}
            additionalOrdering={'is_archived'}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
